import { useEffect } from 'react';

interface SEOSchemaProps {
  schemas: Record<string, unknown>[];
  canonicalUrl?: string;
  pageTitle?: string;
  pageDescription?: string;
  pageKeywords?: string;
  ogTitle?: string;
  ogDescription?: string;
  ogImage?: string;
  ogType?: string;
}

export default function SEOSchema({
  schemas,
  canonicalUrl,
  pageTitle,
  pageDescription,
  pageKeywords,
  ogTitle,
  ogDescription,
  ogImage,
  ogType = 'website',
}: SEOSchemaProps) {
  useEffect(() => {
    if (pageTitle) document.title = pageTitle;

    const setMeta = (name: string, content: string, isProperty = false) => {
      const attr = isProperty ? 'property' : 'name';
      let el = document.querySelector(`meta[${attr}="${name}"]`);
      if (!el) {
        el = document.createElement('meta');
        el.setAttribute(attr, name);
        document.head.appendChild(el);
      }
      el.setAttribute('content', content);
    };

    if (pageDescription) {
      setMeta('description', pageDescription);
      setMeta('og:description', pageDescription, true);
    }
    if (pageKeywords) setMeta('keywords', pageKeywords);
    if (ogTitle) setMeta('og:title', ogTitle, true);
    else if (pageTitle) setMeta('og:title', pageTitle, true);
    if (ogDescription) setMeta('og:description', ogDescription, true);
    if (ogImage) setMeta('og:image', ogImage, true);
    setMeta('og:type', ogType, true);
    if (canonicalUrl) {
      let link = document.querySelector('link[rel="canonical"]');
      if (!link) {
        link = document.createElement('link');
        link.setAttribute('rel', 'canonical');
        document.head.appendChild(link);
      }
      link.setAttribute('href', canonicalUrl);
    }

    const scriptId = 'page-jsonld';
    const existing = document.getElementById(scriptId);
    if (existing) existing.remove();
    const script = document.createElement('script');
    script.id = scriptId;
    script.type = 'application/ld+json';
    if (schemas.length === 1) {
      script.textContent = JSON.stringify(schemas[0]);
    } else {
      script.textContent = JSON.stringify(schemas);
    }
    document.head.appendChild(script);

    return () => {
      const s = document.getElementById(scriptId);
      if (s) s.remove();
    };
  }, []);

  return null;
}